<template>
    <b-form-group :invalid-feedback="invalidFeedback" :label="label" :label-for="formControlId">
        <b-form-textarea
            :id="formControlId"
            :class="potentiallyRequired ? 'border-yellow' : ''"
            :disabled="isReadOnlyProperty"
            :max="max"
            :max-rows="effectiveMaxRows"
            :name="formControlId"
            :required="isRequiredProperty"
            :rows="rows"
            :state="validationState"
            :value="data[property]"
            @input="handleInput"/>
    </b-form-group>
</template>

<script>
    import FormGroupMixin from './FormGroupMixin';

    export default {
        mixins: [FormGroupMixin],
        props: {
            type: {
                type: String,
                default: 'text',
            },
            max: {
                type: Number,
                default: null,
            },
            nullIfEmpty: {
                type: Boolean,
                default: false,
            },
            rows: {
                type: Number,
                default: 3,
            },
            maxRows: {
                type: Number,
                default: null,
            },
        },
        computed: {
            effectiveMaxRows() {
                if (this.maxRows !== null) {
                    return this.maxRows;
                }

                if (this.type === 'autogrowtextarea') {
                    // autogrowtextarea should get an increased default max rows
                    return 35;
                }
                // default for normal textareas is height of 3 rows
                return 3;
            },
        },
        methods: {
            handleInput(input) {
                if (this.nullIfEmpty && !input) {
                    input = null;
                }
                this.data[this.property] = input;
            },
        },
    };
</script>
